export const DEFAULT_AVATAR_URL = 'https://static5.yingsaidata.com/mip/img/llm-avatar.png'
